import { render, staticRenderFns } from "./CustomBlockVoiceDataVivoComponent.vue?vue&type=template&id=57d0f6b6&scoped=true&"
import script from "./CustomBlockVoiceDataVivoComponent.vue?vue&type=script&lang=js&"
export * from "./CustomBlockVoiceDataVivoComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomBlockVoiceDataVivoComponent.vue?vue&type=style&index=0&id=57d0f6b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d0f6b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCheckbox,VCol,VIcon,VRow,VSelect,VSpacer})
